import type { CitationProps } from './Citation.types';

import { FieldName } from '../FieldName';
import { FieldValue } from '../FieldValue';
import { CitationContent } from './elements';

export const Citation = ({ document }: CitationProps) => {
  if (document.citation_ids?.length) {
    return (
      <>
        <FieldName>Citation</FieldName>
        <FieldValue>
          <CitationContent document={document} />
        </FieldValue>
      </>
    );
  }
  return null;
};
